import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const workplace = defineConnector({
  identifier: "workplace",
  name: "Workplace",
  tagLine: "Meta workplace collaboration APIs",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://graph.facebook.com/.*",
  auth: (app) =>
    queryAuth([{ name: "access_token", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Create an app access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://developers.facebook.com/docs/workplace/reference/graph-api](https://developers.facebook.com/docs/workplace/reference/graph-api) to create a custom integration or third-party app access token for the Workplace Graph API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "App access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "input",
          label: "Graph API version",
          placeholder: "v23.0",
          target: {
            kind: "configuration",
            field: "version",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://graph.facebook.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ??
        (({ version = "v23.0" }) => `https://graph.facebook.com/${version}/me`)(
          configuration
        ),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
